const MODULE_NAME = 'floatNumberOnly';
export default angular.module(MODULE_NAME, []).directive('floatNumberOnly', function () {
	'ngInject';
	return {
		require: 'ngModel',
		link: function (scope, element, attrs, modelCtrl) {

			var decimalDigitCount = !isNaN(parseInt(attrs.floatNumberOnly, 10)) ? parseInt(attrs.floatNumberOnly, 10) : 3;

			modelCtrl.$parsers.push(function (inputValue) {
				if (inputValue == undefined) {
					return '';
				}
				var transformedInput = inputValue.replace(/[^0-9,]/g, '');
				var splittedFormedInput = transformedInput.split(',');
				if (splittedFormedInput.length >= 2) {
					transformedInput = splittedFormedInput[0] + ',' + splittedFormedInput[1].substr(0, decimalDigitCount);
				}
				if (transformedInput != inputValue) {
					modelCtrl.$setViewValue(transformedInput);
					modelCtrl.$render();
				}
				return transformedInput;
			});
		}
	};
}).name;



// WEBPACK FOOTER //
// ./source/common/floatnumberonly/floatnumberonly.js